import React, { FC } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

interface DocumentationModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  documentationText: string[];
}

const DocumentationModal: FC<DocumentationModalProps> = (props) => {
  const { isOpen, setIsOpen, documentationText } = props;

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle>Designation Documentation</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {documentationText.map((text, index) => (
            <Grid item xs={12} key={index}>
              <Typography style={{ fontSize: '14px' }}>{text}</Typography>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={() => setIsOpen(false)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentationModal;
